import { Close } from "@mui/icons-material";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Panel, PanelResizeHandle } from "react-resizable-panels";

type TiptapVersionsPanelProps = {
  children?: ReactNode;
  isLoading?: boolean;
  open: boolean;
  onClose: () => void;
};

export const TiptapVersionsPanel = ({
  children,
  isLoading = false,
  open,
  onClose,
}: TiptapVersionsPanelProps) => {
  if (!open) {
    return null;
  }

  return (
    <>
      <PanelResizeHandle className="w-px bg-gray-200 resize-handle shrink-0" />
      <Panel
        id="tiptap-doc-viewer-versions"
        order={1}
        defaultSize={25}
        minSize={15}
        maxSize={50}
        className="min-w-[200px] flex h-[auto] bg-transparent"
      >
        <Box
          className="flex h-full w-full min-w-0 flex-col bg-transparent"
          sx={{ minHeight: 0, overflow: "hidden" }}
        >
          <Box className="flex items-center justify-between py-2 px-3 border-0 border-b border-solid border-gray-200 min-h-[49px]">
            <Box className="flex items-center gap-2">
              <Typography>Versions</Typography>
            </Box>
            <IconButton
              aria-label="Close versions"
              size="small"
              onClick={onClose}
              color="inherit"
              edge="end"
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>

          {isLoading ? (
            <Box className="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-8 text-center text-gray-500">
              <CircularProgress aria-hidden="true" size={24} />
              <Typography variant="body2">Loading versions</Typography>
            </Box>
          ) : (
            <Box className="min-h-0 flex-1 overflow-auto p-3">{children}</Box>
          )}
        </Box>
      </Panel>
    </>
  );
};
